/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { ConfirmBookingAccountEmailChangePayload } from 'api/actions/confirm-booking-account-email-change/confirm-booking-account-email-change-payload';
import { ConfirmBookingAccountEmailChangePathParameters } from 'api/actions/confirm-booking-account-email-change/confirm-booking-account-email-change-path-parameters';
import { ConfirmBookingAccountEmailChangeResponse } from 'api/actions/confirm-booking-account-email-change/confirm-booking-account-email-change-response';

type ConfirmBookingAccountEmailChangeQueryParameters = Record<string, any>;

/**
 * The path of the ConfirmBookingAccountEmailChange action.
 */
export const confirmBookingAccountEmailChangeActionPath = new SweetPath<
  keyof ConfirmBookingAccountEmailChangePathParameters
>('/reservations/account/email-change/confirm', { path: '{param}' });

/**
 * Creates a contextualized ConfirmBookingAccountEmailChange actions.
 */
export default function createConfirmBookingAccountEmailChangeAction(axios: AxiosInstance) {
  return function confirmBookingAccountEmailChangeAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: ConfirmBookingAccountEmailChangeQueryParameters;
    payload: ConfirmBookingAccountEmailChangePayload;
  }) {
    const path = confirmBookingAccountEmailChangeActionPath.original;

    return axios.post<
      ConfirmBookingAccountEmailChangeResponse,
      ConfirmBookingAccountEmailChangeResponse,
      ConfirmBookingAccountEmailChangePayload
    >(path, payload);
  };
}
